/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from "react"
import { GameBoardComponent } from "components/gameBoard/Board"
import SetStake from "components/setStake/index"
import FooterComponent from "./footer/Footer"
import { BoardWrapper } from "./gameBoard/GameBoardStyled"
import { calculateShowResult } from "../functions/calculations"

const Baccarat = ({
  stake,
  handleStake,
  handleAbove,
  handleNotification,
  gameInfo,
  betInfo,
  sendBet,
  bankerStake,
  playerStake,
  tieStake,
  handlePlayerStake,
  handleBankerStake,
  handleTieStake,
  fixedTotalStake,
  handleCurrentStake,
  handleCurrentName,
  currentName,
  isZero,
  handleFinalStake,
  SFXS,
  handleUpdateBalance,
  audio,
  isError,
  finalBalance,
}: any) => {
  //set stake board => active game board
  const [isGameActive, setGameActive] = useState<boolean>(false)
  const handleIsActive = (active: boolean) => setGameActive(active)

  // player cards banker card from betinfo
  const [playerCards, setPlayerCards] = useState<string[]>([])
  const [bankerCards, setBankerCards] = useState<string[]>([])

  // clear cards on rebet, play
  const handleCardsClear = () => {
    setBankerCards([])
    setPlayerCards([])
  }
  useEffect(() => {
    setBankerCards(betInfo.banker.cards)
    setPlayerCards(betInfo.player.cards)
    if (betInfo.banker.cards.length > 0) {
      handleShowResult(
        true,
        calculateShowResult(
          betInfo.banker.cards.length,
          betInfo.player.cards.length,
        ),
      )
    }
  }, [betInfo])

  const [deal, setDeal] = useState(false)

  const handleDeal = (deal: boolean) => setDeal(deal)

  const [showResult, setShowResult] = useState<boolean>(false)

  const [resultDelay, setResultDelay] = useState<number>(0)

  const handleShowResult = (r: boolean, time: number) => {
    if (r) {
      setResultDelay(time)
      setTimeout(() => {
        setShowResult(r)
        handleUpdateBalance(r)
      }, time * 1000 + 1000)
    } else {
      setTimeout(() => {
        setShowResult(r)
        setDealOut(r)
        handleUpdateBalance(r)
      }, 800)
    }
  }

  const [dealOut, setDealOut] = useState(false)

  const handleDealOut = (b: boolean) => {
    setDealOut(b)
  }

  useEffect(() => {
    if (isError) {
      return setGameActive(false)
    }
  }, [isError])

  return (
    <>
      <BoardWrapper isGameActive={isGameActive}>
        <GameBoardComponent
          bankerStake={bankerStake}
          playerStake={playerStake}
          tieStake={tieStake}
          gameInfo={gameInfo}
          betInfo={betInfo}
          bankerCards={bankerCards}
          playerCards={playerCards}
          isGameActive={isGameActive}
          deal={deal}
          dealOut={dealOut}
          showResult={showResult}
          handleShowResult={handleShowResult}
          audio={audio}
        />
        <SetStake
          stake={stake}
          handleStake={handleStake}
          handleAbove={handleAbove}
          SFXS={SFXS}
          handleNotification={handleNotification}
          gameInfo={gameInfo}
          bankerStake={bankerStake}
          playerStake={playerStake}
          tieStake={tieStake}
          handlePlayerStake={handlePlayerStake}
          handleBankerStake={handleBankerStake}
          handleTieStake={handleTieStake}
          handleCurrentStake={handleCurrentStake}
          handleCurrentName={handleCurrentName}
          currentName={currentName}
          isZero={isZero}
          fixedTotalStake={fixedTotalStake}
          handleFinalStake={handleFinalStake}
          isGameActive={isGameActive}
        />
      </BoardWrapper>
      <FooterComponent
        stake={stake}
        SFXS={SFXS}
        gameInfo={gameInfo}
        isGameActive={isGameActive}
        handleAbove={handleAbove}
        handlePlayerStake={handlePlayerStake}
        handleBankerStake={handleBankerStake}
        handleTieStake={handleTieStake}
        handleIsActive={handleIsActive}
        handleDeal={handleDeal}
        handleNotification={handleNotification}
        sendBet={sendBet}
        handleCardsClear={handleCardsClear}
        handleShowResult={handleShowResult}
        handleDealOut={handleDealOut}
        resultDelay={resultDelay}
        showResult={showResult}
        audio={audio}
        isError={isError}
        finalBalance={finalBalance}
      />
    </>
  )
}
export default Baccarat
